/* "Finish your 3" cart guard (Option A, sets of exactly 3 or 6).
   Works on the cart page and in the cart drawer: wherever a checkout button
   ([data-checkout] or [name=checkout]) is on the page, a guard box is placed just
   before it. While eligible polos in the cart are not exactly 3 or 6, the box shows
   and the checkout button is hidden and blocked. Eligibility comes from the same
   catalog the deal uses (BG_SHOP.offerInfo). If the count can't be read, checkout
   is left alone (never a dead end). */
(function(root,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else{root.BG_SETGUARD=api;api.boot(root);}
})(typeof window==='undefined'?globalThis:window,function(){
  'use strict';
  const PICKER='/collections/all?view=pick3';
  const WORDS=['zero','one','two','three','four','five','six'];
  const cap=s=>s.charAt(0).toUpperCase()+s.slice(1);

  /* Pure set math. count = eligible polos in the cart. */
  function setState(count){
    count=Math.max(0,Math.floor(Number(count)||0));
    if(count===0||count===3||count===6)return {blocked:false,count};
    if(count<3)return {blocked:true,count,target:3,heading:'Finish your 3',
      line:count===1?'1 of 3. Your 2 free polos aren’t in your cart yet.':'2 of 3. One free polo still to pick.',
      button:count===1?'Pick my 2 free':'Pick my last free polo',href:PICKER};
    if(count<6){const left=6-count;return {blocked:true,count,target:6,heading:'Finish your 6',
      line:`${count} of 6 picked. ${cap(WORDS[left])} left.`,button:`Pick ${left} more`,href:PICKER};}
    const extra=count-6;
    return {blocked:true,count,target:6,heading:'Polos come in sets of 3 or 6',
      line:`You have ${count} polos. Remove ${extra} ${extra===1?'polo':'polos'} to check out with 6.`,button:null,href:null};
  }

  const CSS='.bg-setguard{border:1px solid #e3e5e0;background:#f5f6f3;border-radius:12px;padding:16px;margin:0 0 14px;color:#171917}'+
    '.bg-setguard[hidden]{display:none!important}.bg-setguard strong{display:block;font-family:"Cormorant Garamond",Georgia,serif;font-weight:500;font-size:26px;line-height:1.1;margin:0 0 6px}'+
    '.bg-setguard p{margin:0 0 12px;color:#70726d;font-size:14px;line-height:1.45}.bg-setguard-track{display:flex;gap:6px;margin:0 0 12px}'+
    '.bg-setguard-track span{flex:1;height:5px;border-radius:5px;background:#e3e5e0}.bg-setguard-track span.filled{background:#344836}'+
    '.bg-setguard a{display:flex;align-items:center;justify-content:center;min-height:48px;border-radius:8px;background:#171917;color:#fff;text-decoration:none;font-weight:600;font-size:15px}';

  function boot(win){
    if(!win||win.__bgSetguardBooted||!win.document)return;win.__bgSetguardBooted=true;
    const doc=win.document;
    let current={blocked:false},revision=0,prepared=false;
    const preview=new URLSearchParams(win.location.search).get('preview_theme_id');
    const link=path=>{const u=new URL(path,win.location.origin);if(preview)u.searchParams.set('preview_theme_id',preview);return u.pathname+u.search;};
    const esc=s=>String(s??'').replace(/[&<>"']/g,c=>'&#'+c.charCodeAt(0)+';');
    if(!doc.getElementById('bg-setguard-css')){const st=doc.createElement('style');st.id='bg-setguard-css';st.textContent=CSS;doc.head.append(st);}
    const buttons=()=>[...doc.querySelectorAll('[data-checkout],button[name="checkout"],input[name="checkout"]')];
    function boxFor(button){
      let box=button.previousElementSibling;
      if(box&&box.classList.contains('bg-setguard'))return box;
      box=doc.createElement('div');box.className='bg-setguard';box.setAttribute('role','status');box.hidden=true;
      button.before(box);return box;
    }
    function apply(state){
      current=state;
      for(const button of buttons()){
        const box=boxFor(button);
        if(state.blocked){
          box.innerHTML=`<strong>${esc(state.heading)}</strong><div class="bg-setguard-track" aria-hidden="true">${Array.from({length:Math.min(state.target,6)},(_,i)=>`<span class="${i<Math.min(state.count,state.target)?'filled':''}"></span>`).join('')}</div><p>${esc(state.line)}</p>${state.button?`<a href="${esc(link(state.href))}" data-setguard-pick>${esc(state.button)}</a>`:''}`;
          box.hidden=false;button.style.display='none';button.setAttribute('aria-hidden','true');
        }else{box.hidden=true;box.innerHTML='';button.style.display='';button.removeAttribute('aria-hidden');}
      }
      doc.documentElement.dataset.setguard=state.blocked?'blocked':'open';
    }
    async function update(){
      const shop=win.BG_SHOP,rev=++revision;
      if(!shop||!shop.cart)return;
      try{
        const info=await shop.offerInfo(shop.cart);if(rev!==revision)return;
        const state=setState(info.count);apply(state);
        // A full set whose deal isn't on the cart yet (e.g. built by a cart link): ask shopping-core to apply it once so the 2 free show at $0 here.
        if(!state.blocked&&info.count>=3&&!info.applied&&!prepared&&typeof shop.prepare==='function'){prepared=true;shop.prepare().catch(()=>{});}
      }
      catch{if(rev===revision)apply({blocked:false});}
    }
    // Server-rendered first state (cart page) avoids a flash of the checkout button.
    const initial=doc.querySelector('[data-setguard-count]');
    if(initial)apply(setState(initial.dataset.setguardCount));
    // Block checkout while incomplete, whatever script owns the button.
    const block=e=>{if(!current.blocked)return;const t=e.type==='submit'?e.submitter:e.target.closest?.('[data-checkout],[name="checkout"]');if(!t||t.name!=='checkout'&&!t.hasAttribute?.('data-checkout'))return;e.preventDefault();e.stopImmediatePropagation();};
    win.addEventListener('click',block,true);win.addEventListener('submit',block,true);
    // Re-check whenever shopping.js re-renders the cart (it rewrites [data-cart-total]).
    const observer=new win.MutationObserver(()=>update());
    const watch=()=>{doc.querySelectorAll('[data-cart-total]').forEach(n=>observer.observe(n,{childList:true,characterData:true,subtree:true}));update();};
    if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',watch);else watch();
    let tries=0;const wait=setInterval(()=>{if(win.BG_SHOP?.cart||++tries>40){clearInterval(wait);update();}},250);
  }
  return {setState,PICKER,boot};
});
